import React, { useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import { seasonTypesArray, seasonTypes as seasonTypesCheck } from "constants/common";
import Spinner from "components/Common/Spinner";
const LotsSold = ({isLoadingLotsSold, carparks, seasonPass, lotsSold}) => {

    return (
        <React.Fragment>
            <Spinner loading={isLoadingLotsSold} />
            <Card>
                <CardBody>
                    <div className="d-flex flex-wrap">
                        <h5 className="card-title me-2">Lots Sold for the Day</h5>
                    </div>
                    <Row className="text-center mt-4">
                        <Col md={12}>
                            <div className="table-responsive">
                                <table className="table mb-0 table">
                                    <thead>
                                        <tr className="table-light">
                                            <th></th>
                                            {carparks.map((el)=> {
                                                return (
                                                    <th key={`CP_${el?._id}`}>{el.carParkTitle || ""}</th>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="table-success">
                                            <th scope="row">Lots Available</th>
                                            {carparks.map(el => (
                                                <td key={el._id}>
                                                    {Array.isArray(el?.vehicleType) ? (                                                    
                                                        el?.vehicleType.map(e =>
                                                        (e.lots || 0) > 0 && e.vehicleType === "car" ? (
                                                            (el.status === "Available" ? e.availableLots : "0")
                                                        ) : null
                                                        )                                                    
                                                    ) : el.vehicleType.vehicleType === "car" ? (
                                                    (el.status === "Available" ? el.vehicleType.availableLots : "0")
                                                    ) : null}
                                                </td>
                                            ))}
                                        </tr>
                                        <tr className="table-success">
                                            <th scope="row">Total</th>
                                            {carparks.map(el => (
                                                <td key={el._id}>
                                                    {Array.isArray(el?.vehicleType) ? (
                                                        (el?.vehicleType.map(e =>
                                                        (e.lots || 0) > 0 && e.vehicleType === "car" ? (
                                                            (el.status === "Available" ? e.lots : "0")
                                                        ) : null
                                                        ))
                                                    ) : el.vehicleType.vehicleType === "car" ? (
                                                    (el.status === "Available" ? el.vehicleType.lots : "0")
                                                    ) : null}
                                                </td>
                                            ))}
                                        </tr>
                                        {/* {seasonTypesArray.map((sobj)=>{
                                            if (sobj !== seasonTypesCheck.Complimentary && sobj !== seasonTypesCheck["N/A"]){
                                                return(
                                                    <>
                                                    <tr>
                                                        <th scope="row">{sobj}</th>
                                                        {carparks.map((cobj,idx)=>{
                                                            return <><td>{lotsSold.user[`${cobj.carParkTitle}`] !== undefined ? lotsSold.user[[`${cobj.carParkTitle}`][`${sobj}`]] !== undefined ? lotsSold.user[[`${cobj.carParkTitle}`][`${sobj}`]] : "0" : "0"}</td></>
                                                        })}
                                                    </tr>
                                                    </>
                                                )
                                            }
                                        })} */}
                                        <tr>
                                            <th scope="row">Monthly</th>
                                            {carparks.map((cobj,idx) => (
                                                <td key={`Msold_${idx}`}>{lotsSold?.user[`${cobj.carParkTitle}`] !== undefined ? lotsSold?.user[`${cobj.carParkTitle}`][`Monthly`] !== undefined ? lotsSold.user[`${cobj.carParkTitle}`][`Monthly`] : "0" : "0"}</td>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th scope="row">Daily</th>
                                            {carparks.map((cobj,idx)=>(
                                                <td key={`Dsold_${idx}`}>{lotsSold?.user[`${cobj.carParkTitle}`] !== undefined ? lotsSold.user[`${cobj.carParkTitle}`][`Daily`] !== undefined ? lotsSold.user[`${cobj.carParkTitle}`][`Daily`] : "0" : "0"}</td>
                                            ))}
                                        </tr>
                                        {/* <tr>
                                            <th scope="row">Monthly</th>
                                            <td>23</td>
                                            <td>12</td>
                                            <td>27</td>
                                            </tr>
                                        <tr>
                                            <th scope="row">Daily</th>
                                            <td>19</td>
                                            <td>35</td>
                                            <td>5</td>
                                        </tr> */}
                                        <tr>
                                            <th scope="row">Guest</th>
                                            {carparks.map((cobj,idx)=>{
                                                return <td key={`Gsold_${idx}`}>{lotsSold?.guest[cobj.carParkTitle] || 0}</td>
                                            })}
                                            {/* <td>3</td>
                                            <td>0</td>
                                            <td>0</td> */}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

LotsSold.propTypes = {
    isLoadingLotsSold: PropTypes.bool,
    carparks: PropTypes.array,
    seasonPass: PropTypes.array,
    lotsSold: PropTypes.object,
  }

export default LotsSold;